// The render presets on one 0–100 scale — Low 0 · Balanced 33 · High 67 ·
// Best 100 — each a pixel ratio and a splat sharpness (covClamp), blended
// between them. The Quality menu's Sharpness slider is this scale (covClamp
// only); a preset's pixel ratio gives the Auto Resolution (SceneHandler.js,
// incl. the phone size tier). ?sharpness= takes a preset name or 0–100.

const ANCHORS = [
  { name: 'low', pos: 0, cov: 0.5, pr: (dpr) => dpr * 0.4 },
  { name: 'balanced', pos: 33, cov: 0.2, pr: (dpr) => dpr * 0.75 },
  { name: 'high', pos: 67, cov: 0.1, pr: (dpr) => Math.min(dpr, 2) },
  { name: 'best', pos: 100, cov: 0.05, pr: (dpr) => Math.min(dpr * 1.5, 3) },
];

export const QUALITY_POS = { low: 0, medium: 10, balanced: 33, high: 67, best: 100 };

const defaultDpr = () => (typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1);

/** Position 0–100 for a ?sharpness= value (preset name or number), or null. */
export function qualityPos(value) {
  if (value == null || value === '') return null;
  if (Object.prototype.hasOwnProperty.call(QUALITY_POS, value)) return QUALITY_POS[value];
  const n = parseFloat(value);
  return Number.isFinite(n) ? Math.max(0, Math.min(100, Math.round(n))) : null;
}

/** { pixelRatio, covClamp } at a position, interpolated between presets. */
export function qualitySettings(pos, dpr = defaultDpr()) {
  const p = Math.max(0, Math.min(100, pos));
  let i = 0;
  while (i < ANCHORS.length - 2 && p > ANCHORS[i + 1].pos) i++;
  const a = ANCHORS[i];
  const b = ANCHORS[i + 1];
  const t = (p - a.pos) / (b.pos - a.pos);
  return {
    pixelRatio: +(a.pr(dpr) + (b.pr(dpr) - a.pr(dpr)) * t).toFixed(3),
    covClamp: +(a.cov + (b.cov - a.cov) * t).toFixed(3),
  };
}
